/**
 * Tiny pure helpers for the city-list cards. Keep these here so the Svelte
 * components stay declarative.
 */

const MS_MIN = 60_000
const MS_HOUR = 60 * MS_MIN
const MS_DAY = 24 * MS_HOUR
const MS_WEEK = 7 * MS_DAY
const MS_MONTH = 30 * MS_DAY
const MS_YEAR = 365 * MS_DAY

export function relativeTime(ts: number, now = Date.now()): string {
  const diff = now - ts
  if (diff < MS_MIN) return 'just now'
  if (diff < MS_HOUR) return `${Math.floor(diff / MS_MIN)} min ago`
  if (diff < MS_DAY) return `${Math.floor(diff / MS_HOUR)} h ago`
  if (diff < MS_WEEK) return `${Math.floor(diff / MS_DAY)} d ago`
  if (diff < MS_MONTH) return `${Math.floor(diff / MS_WEEK)} w ago`
  if (diff < MS_YEAR) return `${Math.floor(diff / MS_MONTH)} mo ago`
  return `${Math.floor(diff / MS_YEAR)} y ago`
}

export function lastEditedLabel(createdAt: number, updatedAt: number, now = Date.now()): string {
  if (Math.abs(updatedAt - createdAt) < 1000) return 'never edited'
  return `edited ${relativeTime(updatedAt, now)}`
}
